import React, { Component } from "react";
import { shanehList } from "../../../settings";
import DropDown from "./dropdown";

export default class RugShanehs extends Component {
  render() {
    return (
      <div style={{ width: "32%" }}>
        <DropDown
          name={this.props.texts.shaneh}
          list={Object.keys(shanehList)}
          selected={this.props.selectedShanehs}
          engName="shanehs"
          changeHandler={this.props.changeHandler}
        />
      </div>
    );
  }
}
